import React from "react";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

const Login = () => {
  const [userName, setUserName] = useState("");

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handlerOnClick = () => {
    dispatch({
      type: "@user/login",
      payload: userName,
    });
    navigate("/pokedex");
  };

  return (
    <div>
      <img
        src="https://i.imgur.com/ODHzBFk.png"
        className=""
        style={{ width: "20vw" }}
      />
      <div className="cColumns cColumns2">
        <p className="tA-right">Hello trainer!</p>
        <img src="https://i.imgur.com/0NGwYtS.png" className="image" alt="" />
      </div>
      <p>Give me your name to start</p>
      <input className="boton" onChange={(e) => setUserName(e.target.value)} />
      <button className="boton" onClick={handlerOnClick}>
        Iniciar Sesion
      </button>
    </div>
  );
};

export default Login;
